import { render, staticRenderFns } from "./LpuDoctorsList.vue?vue&type=template&id=dce4e292&"
import script from "./LpuDoctorsList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuDoctorsList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce4e292')) {
      api.createRecord('dce4e292', component.options)
    } else {
      api.reload('dce4e292', component.options)
    }
    module.hot.accept("./LpuDoctorsList.vue?vue&type=template&id=dce4e292&", function () {
      api.rerender('dce4e292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/LpuDoctorsList.vue"
export default component.exports